export const OWN_BACKEND_PREFIXES = {
  IDENTITY: 'identity',
  MAP_POI: 'map-poi'
}